import { useEffect, useRef } from 'react'
import { useTalkLog } from '../lib/talkLog'

export default function Console() {
  const { lines, clear } = useTalkLog()
  const consoleRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (consoleRef.current) consoleRef.current.scrollTop = consoleRef.current.scrollHeight
  }, [lines])

  return (
    <div className="console-page">
      <div className="talk-toolbar">
        <button type="button" className="warn" onClick={clear} disabled={lines.length === 0}>
          Clear log
        </button>
        <div className="spacer" />
        <span className="status-pill">{lines.length} lines</span>
      </div>
      <div ref={consoleRef} className="talk-console" aria-live="polite" data-testid="talk-console">
        {lines.length === 0 ? (
          <p className="text-chat-empty">The chat log appears here. It stays when you leave the conversation.</p>
        ) : (
          lines.map((line) => (
            <div key={line.id} className="line">
              <span className="ts">{line.ts}</span>
              <span className={`tag ${line.tag}`}>{line.tag}</span>
              <span className={`msg${line.partial ? ' partial' : ''}`}>{line.msg}</span>
            </div>
          ))
        )}
      </div>
    </div>
  )
}
